import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './components/home/home.component';
import { BusinessComponent } from './components/business/business.component';
import { BusinessDetailsComponent } from './components/business/business-details/business-details.component';
import { ProductsComponent } from './components/product/products.component';
import { ProductDetailsComponent } from './components/product/product-details/product-details.component';
import { AuthGuard } from './helpers/auth.guard';
import { AboutComponent } from './components/staticPages/about/about.component';
import { ContactComponent } from './components/staticPages/contact/contact.component';
import { PriceDetailsComponent } from './components/staticPages/price-details/price-details.component';
import { PrivacyPolicyComponent } from './components/staticPages/privacy-policy/privacy-policy.component';
import { ReturnPolicyComponent } from './components/staticPages/return-policy/return-policy.component';
import { ShippingPolicyComponent } from './components/staticPages/shipping-policy/shipping-policy.component';
import { TermsComponent } from './components/staticPages/terms/terms.component';
import { NewsDetailsComponent } from './components/blog/news-details/news-details.component';
import { NewsComponent } from './components/blog/news/news.component';
import { NotFoundComponent } from './components/staticPages/not-found/not-found.component';
import { BookingComponent } from './components/checkout/booking/booking.component';
import { InvoiceComponent } from './components/checkout/invoice/invoice.component';
import { RegisterComponent } from './components/register/register.component';
import { ProfileComponent } from './components/dashboard/profile/profile.component';
import { LoginComponent } from './components/login/login.component';
import { SearchComponent } from './components/search/search.component';
import { CartComponent } from './components/checkout/cart/cart.component';
import { RefundPolicyComponent } from './components/staticPages/refund-policy/refund-policy.component';
import { VerifyComponent } from './components/staticPages/verify-email/verify.component';
import { PaymentSuccessComponent } from './components/staticPages/payment-success/payment-success.component';
import { PaymentFailedComponent } from './components/staticPages/payment-failed/payment-failed.component';
import { SiteMapComponent } from './components/staticPages/site-map/site-map.component';


const routes: Routes = [
  {
    path: "",
    component: HomeComponent
  },
  {
    path: "home",
    component: HomeComponent
  },
  { path: 'search', component: SearchComponent, title: 'Search List'},
  { path: 'search/:findAny', component: SearchComponent, title: 'Search List' },
  { path: 'search/:type/:name/:location/:category', component: SearchComponent, title: 'Search List' },
  { path: 'business', component: BusinessComponent, title: 'Business List' },
  { path: 'business/:name', component: BusinessComponent, title: 'Business List' },
  { path: 'business/:name/:id', component: BusinessComponent, title: 'Business List' },
  { path: 'business-details/:uid', component: BusinessDetailsComponent, title: 'Business Details' },
  { path: 'business-details/:uid/:name', component: BusinessDetailsComponent, title: 'Business Details' },
  { path: 'products', component: ProductsComponent, title: 'Product List' },
  { path: 'products/:name/:id', component: ProductsComponent, title: 'Product' },
  { path: 'product-details/:uid/:id', component: ProductDetailsComponent, title: 'Product Details' },
  {
    path: 'news',
    loadChildren: () => import('./components/blog/news/news.module').then(m => m.NewsModule),
    children: [
      { path: '', component: NewsComponent, title: 'News' },
      { path: 'news-details', component: NewsDetailsComponent, title: 'News Details' },
    ]
  },
  {
    path: 'checkout/:paymentOrderId',
    loadChildren: () => import('./components/checkout/booking/booking.module').then(m => m.BookingModule),
    children: [
      { path: '', component: BookingComponent, title: 'Checkout Details' },
      { path: 'invoice-details', component: InvoiceComponent, title: 'Invoice Details' },
    ]
  },
  {
    path: 'cart',
    component: CartComponent, title: 'Cart Details',
    children: [
      { path: 'checkout', component: BookingComponent, title: 'Checkout Details' },
      { path: 'invoice-details', component: InvoiceComponent, title: 'Invoice Details' },
    ]
  },
  {
    path: 'register',
    component: RegisterComponent, title: 'Register'
  },
  {
    path: 'login',
    component: LoginComponent, title: 'Login'
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./components/resetPassword/reset.module').then(m => m.ResetModule), 
    title: 'Reset Password'
  },
  {
    path: 'verify/:id/:email', component: VerifyComponent, title: 'Verify Email'
  },
  {
    path: 'payment-success', component: PaymentSuccessComponent, title: 'Payment Success'
  },
  {
    path: 'payment-failed', component: PaymentFailedComponent, title: 'Payment Failed'
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard],
    loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule),
    title: 'Dashboard'
  },
  {
    path: 'about', component: AboutComponent, title: 'About'
  },
  {
    path: 'contact', component: ContactComponent, title: 'Contact'
  },
  {
    path: 'price', component: PriceDetailsComponent, title: 'Price List'
  },
  {
    path: 'advertising-plan', component: PriceDetailsComponent, title: 'Price List'
  },
  {
    path: 'privacy-policy', component: PrivacyPolicyComponent, title: 'Privacy Policy'
  },
  {
    path: 'return-policy', component: ReturnPolicyComponent, title: 'Return Policy'
  },
  {
    path: 'refund-and-cancellation', component: RefundPolicyComponent, title: 'Refund and Cancellation Policy'
  },
  {
    path: 'shipping-policy', component: ShippingPolicyComponent, title: 'Shipping Policy'
  },
  {
    path: 'terms-and-conditions', component: TermsComponent, title: 'Terms and Conditions'
  },
  {
    path: 'site-map', component: SiteMapComponent, title: 'Site Map'
  },
  {
    path: '**',
    component: NotFoundComponent,
  }
];

@NgModule({
  imports: [BrowserModule, RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', initialNavigation: 'enabledBlocking' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
